import { useState, type ChangeEvent, type FunctionComponent } from 'react';
import * as styles from './ActiveSubscriptionAlert.module.scss';

export interface ActiveSubscriptionAlertProps {
  onCheckedChange: (isChecked: boolean) => void;
}

const LABELS = {
  TITLE: 'Wait, You Have Active Subscription(s) Shipping With Your Box',
  MESSAGE:
    'If you cancel, these subscriptions will expire at the end of your membership period. Note: any subscriptions shipping outside of your box will remain active.',
  CHECKBOX_TEXT:
    'I understand that once I cancel my membership, any subscriptions that ship with my box will automatically expire at the end of my membership period.',
  CHECKBOX_BOLD:
    'Subscriptions that ship separately from the box will remain active and must be cancelled from My Subscriptions.',
};

const ActiveSubscriptionAlert: FunctionComponent<ActiveSubscriptionAlertProps> = ({
  onCheckedChange,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleClickCheckBox = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    onCheckedChange(checked);
  };

  return (
    <div
      className={styles.activeSubscriptionAlertContainer}
      data-testid="active-subscription-alert-container"
    >
      <div className={styles.alertBox}>
        <h2 className={styles.title}>{LABELS.TITLE}</h2>
        <p className={styles.message}>{LABELS.MESSAGE}</p>
      </div>
      <div className={styles.checkboxContainer}>
        <label htmlFor="checkbox-active-subscription" className={styles.checkboxLabel}>
          <input
            type="checkbox"
            id="checkbox-active-subscription"
            onChange={handleClickCheckBox}
            checked={isChecked}
          />
          <span className={styles.checkbox} />
          <span className={styles.disclaimer}>
            {LABELS.CHECKBOX_TEXT} <strong>{LABELS.CHECKBOX_BOLD}</strong>
          </span>
        </label>
      </div>
    </div>
  );
};

export default ActiveSubscriptionAlert;
